export const AI_CONSTANTS = {
    MAX_QUESTIONS: 3,
    TEXTAREA_MIN_HEIGHT: 48,
    TEXTAREA_MAX_HEIGHT: 120,
    INTERSECTION_THRESHOLD: 0.8,
} as const;

export const MESSAGES = {
    FIRST_MESSAGE: '검사 결과와 관련하여 궁금한 점이 있으시면 질문해보세요.\n\n"불안이 높다고 나오면 생활에 어떤 영향을 주나요?"\n"이 결과가 꼭 치료가 필요하다는 뜻인가요?"',
    PLACEHOLDER_DEFAULT: '검사 관련 질문을 입력하세요.',
    PLACEHOLDER_LIMIT_REACHED: '3회 질문이 완료되었습니다.',
    LIMIT_REACHED_SUFFIX: '\n\n※ 3회 질문이 모두 완료되었습니다.',
    INITIALIZATION_ERROR: 'AI 서비스 초기화 중입니다.',
    RESPONSE_ERROR: '죄송합니다. 응답을 생성하는 중 오류가 발생했습니다. 다시 시도해 주세요.',
} as const;

export const MODAL_CONTENT = {
    ENTER_MODAL: {
        TITLE: '이용 전 꼭 확인해주세요.',
        BUTTON: '확인',
        ITEMS: [
            { first: '질문은', medium: ' 최대 3개까지 ', last: '가능해요.' },
            { first: '전문 상담이나 진단을 대체할 수 없으니', medium: ' 참고용으로 활용', last: '하세요' },
            { first: '', medium: '개인정보 전송 시 주의', last: '해주세요' },
        ],
    },
    HELP_MODAL: {
        TITLE: '서비스 이용 안내',
        BUTTON: '확인',
        ITEMS: [
            { title: '답변 제공', content: 'OpenAI ChatGPT\n(gpt-4o-mini)' },
            { title: '질문 횟수', content: '최대 3회' },
            { title: '질문 범위', content: '자유 질문' },
            { title: '답변 성격', content: '참고용 (진단 아님)' },
        ],
    },
} as const;

export const INITIALIZATION_STATUS = {
    INITIALIZING: '초기화 중...',
    VERIFYING_ACCESS: 'AI 액세스 검증 중...',
    CREATING_INSTANCE: 'OpenAI API 인스턴스 생성 중...',
    INITIALIZING_ASSISTANT: 'Assistant 초기화 중...',
    CREATING_THREAD: 'Thread 생성 중...',
    COMPLETED: '초기화 완료',
    INSUFFICIENT_DATA: '필요한 데이터가 부족합니다.',
} as const;